import axios from "axios";
import { jwtDecode } from "jwt-decode";

export const FloorListAction = (buildingId = null) => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "FLOOR_LIST_LOADING" });
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/floor/floorList`;
    if (buildingId) {
      url += `?buildingId=${buildingId}`;
    }
    
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "FLOOR_LIST_SUCCESS",
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: "FLOOR_LIST_ERROR",
      payload: error.response,
    });
  }
};

export const fetAllFloorData = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: "FLOOR_LIST_LOADING" });
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/v1/floor/floorList`;
    const requestBody = {
      customerIds: filters.customerNames ?? [],
      buildingIds: filters.buildingId ?? [],
      floorNames: filters.floorName.length > 0 ? filters.floorName : [],
      sortBy: filters.sortBy || "createdAt",
      sortDirection: filters.sortDirection || "DESC",
      typeIds: filters.typeIds,
      isDeleted: false,
      page: filters.page ?? 0,
      size: filters.size ?? 5,
    };
    const response = await axios.post(url, requestBody, {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({ type: "FLOOR_LIST_SUCCESS", payload: response.data });
    }
  } catch (error) {
    dispatch({
      type: "FLOOR_LIST_ERROR",
      payload: error.response?.data || error.message,
    });
  }
};

export const fetchBuildingDataAction = () => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "FETCH_BUILDING_DATA_LOADING" });
  
  try {
    const response = await axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_ALL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      dispatch({
        type: "FETCH_BUILDING_DATA_SUCCESS",
        payload: response.data.buildings || response.data.data || response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: "FETCH_BUILDING_DATA_ERROR",
      payload: error.response?.data || "Failed to fetch building data",
    });
  }
};

export const deleteFloor = (id, filters) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const url = `${process.env.REACT_APP_API_NEW_URL}/floor/${id}`;
  dispatch({ type: "DELETE_FLOOR_LOADING" });
  try {
    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({
        type: "DELETE_FLOOR_SUCCESS",
        payload: id,
      });
      dispatch(fetAllFloorData(filters));
    } else {
      dispatch({
        type: "DELETE_FLOOR_ERROR",
        payload: "Failed to delete floor",
      });
    }
  } catch (error) {
    dispatch({
      type: "DELETE_FLOOR_ERROR",
      payload: error.response?.data || "Something went wrong",
    });
  }
};

export const getUserListAction = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "USER_LIST_LOADING" });
  try {
    const url = `${process.env.REACT_APP_API_URL}/getUserList`;
    const response = await axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "GET_USER_LIST_SUCCESS",
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: "GET_USER_LIST_ERROR",
      payload: error.response,
    });
  }
};

export const addFloor = (formData, uploadedFile, filters) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const decodedToken = jwtDecode(token);

  // const floorUsers = formData.selectedAdmins.map((admin) => ({
  //   userGuid: admin.userGuid,
  //   name: admin.name,
  // }));

  const url = new URL(`${process.env.REACT_APP_API_URL}/floor/addFloor`);
  url.searchParams.append("floorName", formData.floor);
  url.searchParams.append("createdBy", decodedToken.email);
  url.searchParams.append("buildingId", formData.buildingId);

  const formDataToSend = new FormData();
  if (uploadedFile) {
    formDataToSend.append("floorImage", uploadedFile);
  }
  // formDataToSend.append("floorUsers", JSON.stringify(floorUsers));

  dispatch({ type: "ADD_FLOOR_LOADING" });

  try {
    const response = await axios.post(url.toString(), formDataToSend, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 201) {
      dispatch({ type: "ADD_FLOOR_SUCCESS", payload: response.data });
      dispatch(fetAllFloorData(filters));
    }
  } catch (error) {
    dispatch({
      type: "ADD_FLOOR_ERROR",
      payload: error?.response?.data?.message || "Something went wrong",
    });
  }
};

export const editFloor =
  (formData, uploadedFile, editId, filters) => async (dispatch) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);

    // const floorUsers = formData.selectedAdmins.map((admin) => ({
    //   userGuid: admin.userGuid,
    //   name: admin.name,
    // }));

    const formDataToSend = new FormData();
    formDataToSend.append("floorName", formData.floor);
    formDataToSend.append("createdBy", decodedToken.email);
    formDataToSend.append("buildingId", formData.buildingId);

    if (uploadedFile) {
      formDataToSend.append("floorImage", uploadedFile);
    }

    // formDataToSend.append("floorUsers", JSON.stringify(floorUsers));

    dispatch({ type: "EDIT_FLOOR_LOADING" });

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/floor/update/${editId}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        dispatch({ type: "EDIT_FLOOR_SUCCESS" });
        dispatch(fetAllFloorData(filters));
      }
    } catch (error) {
      dispatch({
        type: "EDIT_FLOOR_ERROR",
        payload: error?.response?.data?.message || "Something went wrong",
      });
    }
  };

export const updateDeviceCoordinatesAction =
  (device, selectedFloor) => async (dispatch) => {
    dispatch({ type: "UPDATE_DEVICE_COORDINATES_REQUEST" });

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const decodedToken = jwtDecode(token);
      const url = `${process.env.REACT_APP_API_NEW_URL}/device/update/${device.id}`;

      const payload = {
        id: device.id,
        name: device.name,
        cssXCoordinate: device.cssXCoordinate,
        cssYCoordinate: device.cssYCoordinate,
        type: device.type,
        deviceLocationName: device.deviceLocationName || "",
        deviceLocationId: device.deviceLocationId || "",
        triggeredByDeviceId: [0],
        deleted: false,
        createdAt: device.createdAt,
        modifiedAt: new Date().toISOString(),
        createdBy: device.createdBy,
        modifiedBy: decodedToken.userGuid,
        triggeredBy: device.triggeredBy,
        deviceMake: device.deviceMake,
        status: device.status,
        serialNumber: device.serialNumber,
        installed: device.installed,
        macAddress: device.macAddress,
        ipAddress: device.ipAddress,
        topicName: device.topicName,
        cameraType: device.cameraType,
        streamUrl: device.streamUrl,
        videoLength: device.videoLength,
      };

      const response = await axios.put(url, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        dispatch({
          type: "UPDATE_DEVICE_COORDINATES_SUCCESS",
          payload: response.data, // Assuming the response contains updated device data
        });
        dispatch(fetchMissingDevices());
        dispatch(fetchFloorDevices());
        dispatch(FloorListAction());        
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_DEVICE_COORDINATES_FAILURE",
        payload: error.message,
      });
      console.error("Error updating device coordinates:", error);
    }
  };

export const fetchMissingDevices = () => async (dispatch) => {
  dispatch({ type: "FETCH_DEVICES_REQUEST" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_NEW_URL}/api/v1/device/data/getDevicesMissingLocation`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "FETCH_DEVICES_SUCCESS",
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: "FETCH_DEVICES_FAILURE",
      payload: error.message,
    });
    console.error("Error making request:", error);
  }
};
export const fetchFloorDevices = (selectedFloor) => async (dispatch) => {
  dispatch({ type: "FETCH_FLOOR_DEVICES_REQUEST" });
  try {
    if (!selectedFloor?.id) {
      console.error("Selected floor is undefined or missing id");
      return; // Exit early if selectedFloor is invalid
    }
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_NEW_URL}/device/set-coord/data/location/${selectedFloor.id}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({
        type: "FETCH_FLOOR_DEVICES_SUCCESS",
        payload: response,
      });
    }
  } catch (error) {
    dispatch({
      type: "FETCH_FLOOR_DEVICES_FAILURE",
      payload: error.message,
    });
    console.error("Error making request:", error);
  }
};
export const updatedFloor = (id) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_FLOOR_REQUEST" }); // Start loading

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const url = `${process.env.REACT_APP_API_NEW_URL}/floor/floorList`;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const floors = response.data;
        const selectedFloor = floors.find(
          (floor) => floor.id === parseInt(id, 10)
        );

        if (selectedFloor) {
          dispatch({
            type: "FETCH_FLOOR_SUCCESS",
            payload: selectedFloor,
          });
        } else {
          console.warn(`Floor with ID ${id} not found`);
          dispatch({
            type: "FETCH_FLOOR_FAILURE",
            error: `Floor with ID ${id} not found`,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching floor details:", error);
      dispatch({
        type: "FETCH_FLOOR_FAILURE",
        error: error.message || "Error fetching floor details",
      });
    }
  };
};

export const deleteItem = (device) => async (dispatch) => {
  dispatch({ type: "DELETE_DEVICE_ITEM_REQUEST" });
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);
    const formDataToSend = {
      id: device.id,
      name: device.name,
      cssXCoordinate: 0,
      cssYCoordinate: 0,
      type: device.type,
      deviceLocationName: device.deviceLocationName,
      deviceLocationId: null,
      triggeredByDeviceId: [0],
      deleted: false,
      createdAt: device.createdAt,
      modifiedAt: new Date().toISOString(),
      createdBy: device.createdBy,
      modifiedBy: decodedToken.userGuid,
      triggeredBy: device.triggeredBy,
      deviceMake: device.deviceMake,
      status: device.status,
      serialNumber: device.serialNumber,
      installed: device.installed,
      macAddress: device.macAddress,
      ipAddress: device.ipAddress,
      topicName: device.topicName,
      cameraType: device.cameraType,
      streamUrl: device.streamUrl,
      videoLength: device.videoLength,
    };
    const url = `${process.env.REACT_APP_API_NEW_URL}/device/update/${device.id}`;
    const response = await axios({
      method: "PUT",
      url: url,
      data: formDataToSend,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch(fetchMissingDevices());
      dispatch(fetchFloorDevices());
    }
  } catch (error) {
    console.error("Error deleting item:", error);
    dispatch({
      type: "DELETE_ITEM_FAILURE",
      error: error.message,
    });
  }
};
export const resetMissingDevice = () => ({
  type: "RESET_MISSING_DEVICE",
});

export const updatedFloorId = (id) => async (dispatch) => {
  dispatch({
    type: "UPDATED_FLOOR_ID",
    payload: id,
  });
};

// download blueprint
export const downloadFloorBlueprint = (floorId) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "DOWNLOAD_BLUEPRINT_LOADING" });
  try {
    const response = await axios({
      method: "GET",
      url: `${process.env.REACT_APP_DEVICE_API_URL}/api/floorBlueprint/download?floorId=${floorId}`,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const blob = new Blob([response.data], { type: response.data.type });
    const urlBlob = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const extension = response.data.type.includes("png") ? "png" : "jpg";
    link.href = urlBlob;
    link.download = `floor_blueprint_${floorId}.${extension}`;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(urlBlob);
    document.body.removeChild(link);

    dispatch({ type: "DOWNLOAD_BLUEPRINT_SUCCESS" });
  } catch (error) {
    dispatch({
      type: "DOWNLOAD_BLUEPRINT_ERROR",
      payload: error?.response || error.message,
    });
  }
};